import Modal from "../../../components/ui/Modal";
import { useTranslation } from "react-i18next";
import FileUploadArea from "../../../components/ui/FielUploadArea";

function ItemPictureForm({
  modalPictureFormIsOpen,
  setModalPictureFormIsOpen,
  itemSelected,
  setItemSelected,
  hidePictures = false,
}) {
  const { t } = useTranslation();

  return (
    <div>
      {modalPictureFormIsOpen && (
        <Modal
          showModal={modalPictureFormIsOpen}
          setShowModal={setModalPictureFormIsOpen}
          title={t("settings.items.uploadPicture")}
          sendLabel={t("global.btn.add")}
          footer={false}
        >
          <div>
            {itemSelected?.itemPictures.length > 0 && !hidePictures && (
              <PicturesList item={itemSelected} />
            )}

            <div className="grid grid-cols-12">
              <div className="col-span-12 px-3">
                <FileUploadArea
                  submitUrl={
                    process.env.REACT_APP_API_URL + "/api/item_pictures"
                  }
                  formDataExtraValues={[{ item: itemSelected["@id"] }]}
                  successFn={(e) => {
                    let newItem = { ...itemSelected };
                    newItem.itemPictures.push(e);
                    setItemSelected(newItem);
                    setModalPictureFormIsOpen(false);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default ItemPictureForm;
